export const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};
